import {
  getRefreshToken,
  removeRefreshToken,
  removeToken,
  setRefreshToken,
  setToken
} from '@/utils/auth.js';
import { useUserStore } from '@/stores/index.js'

export function refreshToken(service) {
  return new Promise((resolve) => {
    let refreshToken = getRefreshToken();
    if (refreshToken) {
      const scope = useUserStore()?.userInfo?.scope || '1'
      service
        .request({
          url: '/oauth/token',
          method: 'post',
          withCredentials: true,
          data: `grant_type=refresh_token&scope=${scope}&refresh_token=` + refreshToken,
          auth: {
            username: 'browser',
            password: 'browser'
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then((res) => {
          // 重新设置token和refreshToken
          if (res.access_token) {
            setToken(res.access_token);
            setRefreshToken(res.refresh_token);

            let versionInfo = res.versionInfo || {}
            versionInfo.validStartDate = res.validStartDate || ''
            versionInfo.validEndDate = res.validEndDate || ''
            const userInfo = {
              id: res.id,
              fullName: res.firstName + ' ' + res.lastName,
              firstName: res.firstName,
              lastName: res.lastName,
              email: res.email,
              role: res.role,
              status: res.status,
              scope: res.scope,
              versionInfo: versionInfo,
              mobile: res.mobile
            }
            useUserStore().setUser(userInfo)

            resolve({
              statusText: 'success'
            });
          } else {
            resolve({
              statusText: '刷新失败'
            });
          }
        })
        .catch(() => {
          removeToken();
          removeRefreshToken();
          resolve({
            statusText: '刷新失败'
          });
        });
    } else {
      resolve({
        statusText: '未登录'
      });
    }
  });
}
